import CloseIcon from '@src/assets/images/common/icon/close.svg';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';

const ConfirmDeleteModal: React.FC<{
  onConfirm: () => void;
  onClose: () => void;
  name?: string;
}> = ({ onConfirm, onClose, name }) => {
  return (
    <Modal width='440px'>
      <div className='relative flex grow flex-col gap-8 px-10 py-9'>
        <div className='border-b border-b-gray-350 pb-[10px]'>
          <h2 className='text-lg font-semibold'>チャンネルを削除しますか？</h2>
        </div>
        <p className='break-words text-sm'>「{name}」が完全に削除されますがよろしいですか？</p>
        <div className='mt-auto flex w-full justify-around gap-5 lg:flex-col'>
          <Button
            size='m'
            variant='secondary'
            fullRounded
            fullWidth
            onClick={onConfirm}
          >
            完全に削除
          </Button>
          <Button
            size='m'
            variant='primary'
            outline
            fullRounded
            fullWidth
            onClick={onClose}
          >
            戻る
          </Button>
        </div>
        <button
          className='absolute right-3 top-3 grid size-[20px] place-items-center rounded-full bg-gray-50 hover:opacity-60 hover:transition-opacity'
          onClick={onClose}
        >
          <img
            src={CloseIcon}
            alt='閉じる'
            width={20}
            height={20}
            loading='lazy'
          />
        </button>
      </div>
    </Modal>
  );
};

export { ConfirmDeleteModal };
